export default __webpack_public_path__ + "static/media/modobupdesc.42ceebd3.pdf";